import React from 'react';
import Inicio from './Inicio';
import Header from './Header';
import WhoWeAre from './WhoWeAre';
import HowWeWork from './HowWeWork';
import SuccessStories from './SuccessStories';
import Contact from './Contact';
import Footer from './Footer';
// import OurTeam from './OurTeam';
import OurRelevantMarketingCampaigns from './OurRelevantMarketingCampaigns';

function App() {
  return (
    <div>
      <Header />
      <Inicio />
      <div id="who-we-are" style={{ scrollMarginTop: '5rem', marginTop: '5rem' }}>
        <WhoWeAre />
      </div>
      <div id="success-stories" style={{ scrollMarginTop: '5rem', marginTop: '5rem' }}>
        <SuccessStories />
      </div>
      <div id="how-we-work" style={{ scrollMarginTop: '5rem', marginTop: '5rem' }}>
        <HowWeWork />
      </div>
      <div id="marketing" style={{ scrollMarginTop: '5rem', marginTop: '5rem' }}>
        <OurRelevantMarketingCampaigns />
      </div>
      {/* <div id="our-team" style={{ scrollMarginTop: '5rem', marginTop: '5rem' }}>
        <OurTeam />
      </div> */}
      <div id="contact" style={{ scrollMarginTop: '5rem' }}>
        <Contact />
      </div>
      <div id="footer">
        <Footer />
      </div>
    </div>
  );
}

export default App;
